import {
  Button,
  Checkbox,
  Col,
  Drawer,
  Form,
  Input,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import "../../../../CapsitechAccountsComponents/Pages/Users/User.css";
import UsersService, {
  SelectClientsType,
} from "../../../Services/UsersService";
import ClientService from "../../../Services/ClientService";
import { Utils } from "../../../../Utilities/Utils";
import {
  CloseOutlined,
  DeleteTwoTone,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import AddCompanyRoles from "../Roles/AddClientRoles";
import ClientRoleServices from "../../../Services/ClientRoleServices";
import CustomerRoleServices from "../../../Services/CustomerRoleServices";
import { useUser } from "../../../../Context/UserContext";
import { IIdNameModel } from "../../../Services/ItemsService";
import { MD5 } from "crypto-js";
import { useHotkey } from "../../../Context/HotKeyContext";
import EntryLevelKeys from "../../../Common/EntryLevelKeys";

interface props {
  onCancel: any;
  isModelOpen: boolean;
  editUserId: string | undefined;
  setRefresh: any;
}

const AddUser = ({ onCancel, isModelOpen, editUserId, setRefresh }: props) => {
  const { showKeys } = useHotkey();
  const { Option, OptGroup } = Select;
  const [form] = Form.useForm();
  const { getUserId, getProducts } = useUser();
  console.log("getProducts", getProducts());
  const userId = getUserId();
  const [btnLoading, setBtnLoading] = useState<any>(false);
  const [drawerLoading, setDrawerLoading] = useState<boolean>(false);
  const [clientList, setClientList] = useState<any[]>([]);
  const [customerRoleList, setCustomerRoleList] = useState<any[]>([]);
  const [clientSpecificRoleList, setClientSpecificRoleList] = useState<any[]>(
    []
  );
  // const [selectedClients, setSelectedClients] = useState<string[]>([]);
  const [selectAllChecked, setSelectAllChecked] = useState<boolean>(false);
  const [isClientWiseRole, setisClientWiseRole] = useState<boolean>(false);
  const [selectedClientId, setSelectedClientId] = useState<string[]>([]);
  const [openModel, setOpenModel] = useState<{
    type: string;
    clientId: string;
  }>({
    type: "",
    clientId: "",
  });
  const [selectClientsType, setSelectClientsType] = useState<SelectClientsType>(
    SelectClientsType.SelectClients
  );
  const [trigger, setTrigger] = React.useState<boolean>(false);
  const [isEditTrigger, setIsEditTrigger] = React.useState<boolean>(false);

  const [newClientRoleIndex, setNewClientRoleIndex] = useState<number>(-1);
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  // getAllRoleIdNameList;

  useEffect(() => {
    const getAllRoleIdNameList = async () => {
      try {
        setDrawerLoading(true);

        const [CustomerRole, ClientAll] = await Promise.all([
          CustomerRoleServices?.getAllRoleIdNameList(userId!),
          ClientService?.getAllClientList(false, ""),
        ]);

        // let res = await CustomerRoleServices?.getAllRoleIdNameList(userId!);
        // // console.log("res 111", res.result);
        if (CustomerRole.result?.length > 0) {
          setCustomerRoleList(
            CustomerRole?.result?.map((x: IIdNameModel) => {
              return {
                label: x.name,
                value: x.id,
              };
            })
          );
        }
        if (ClientAll) {
          setClientList(ClientAll?.items);
        }
        setIsEditTrigger(true);
      } catch (ex) {
        console.error("error", ex);
      } finally {
        !editUserId && setDrawerLoading(false);
      }
    };
    getAllRoleIdNameList();
  }, []);

  // console.log("clientId", selectedClientId);
  useEffect(() => {
    if (editUserId && isEditTrigger) {
      const getUserDataById = async () => {
        try {
          setDrawerLoading(true);
          let res = await UsersService?.getUserDataById(editUserId);
          if (res.result) {
            form.setFieldsValue({
              first: res.result?.name?.first,
              last: res.result?.name?.last,
              email: res.result?.email,
              phoneNumber: res.result?.phoneNumber,
              clientSpecificRole: res.result?.clientSpecificRole,
              clientRoleList: res.result?.clientSpecificRole
                ? [
                    ...res.result?.clientRoleList?.map((x: any) => {
                      const client = clientList.find((y) => y.id === x.id[0]);
                      console.log("label", clientList, client?.bName);
                      return {
                        roleId: { label: x?.roleName, value: x?.roleId },
                        id: { label: client?.bName, value: x.id[0] },
                        isClientRole: x?.isClientRole,
                      };
                    }),
                    {},
                  ]
                : res.result?.roleClientsType ===
                  SelectClientsType.SelectClients
                ? [
                    {
                      id: res.result?.clientRoleList[0]?.id,
                      roleId: {
                        label: res.result?.clientRoleList[0]?.roleName,
                        value: res.result?.clientRoleList[0]?.roleId,
                        isClientRole:
                          res.result?.clientRoleList[0]?.isClientRole,
                      },
                    },
                  ]
                : [
                    {
                      roleId: {
                        label: res.result?.clientRoleList[0]?.roleName,
                        value: res.result?.clientRoleList[0]?.roleId,
                        isClientRole: res.result?.clientRoleList?.isClientRole,
                      },
                    },
                  ],
            });
            // console.log("result", res);
            if (res.result?.clientSpecificRole) {
              const clientId = res.result?.clientRoleList?.map(
                (x: any, index: number) => {
                  return x.id[0];
                }
              );
              // console.log("clientId", clientId, selectedClientId)  ;

              setSelectedClientId(clientId);

              try {
                let res = await ClientRoleServices.getAllRoleIdNameList(
                  clientId
                );
                // console.log("res 111", res.result);
                if (res.result?.length > 0) {
                  const allClientRoles = res?.result;
                  for (let index = 0; index < clientId?.length; index++) {
                    const roles = allClientRoles?.find(
                      (x: any) => x._id === clientId[index]
                    );
                    // console.log("roles", roles, allClientRoles);
                    if (roles) {
                      setClientSpecificRoleList((prevDataArray) => {
                        const newArray = [...prevDataArray];
                        newArray[index] =
                          roles?.roleData?.length > 0 ? roles?.roleData : [];
                        return newArray;
                      });
                    }
                  }
                }
              } catch (ex) {
                console.error("error", ex);
              } finally {
              }
            }

            setisClientWiseRole(res.result?.clientSpecificRole);
            setSelectClientsType(res.result?.roleClientsType);

            console.log("ress", res);
          }
        } catch (ex) {
          console.error(ex);
        } finally {
          setDrawerLoading(false);
        }
      };
      getUserDataById();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editUserId, isEditTrigger]);

  const handleSelectAll = (e: any) => {
    const checked = e.target.checked;
    setSelectAllChecked(checked);
    if (checked) {
      form.setFieldValue(
        ["clientRoleList", 0, "id"],
        clientList?.map((client: any) => client.id)
      );
      // setSelectedClients(clientList?.map((client: any) => client.id));
    } else {
      // form.getFieldError(["clientRoleList", 0, "id"]);
      form.setFieldValue(["clientRoleList", 0, "id"], undefined);
    }
  };

  const handleSelectChange = (selectedValues: string[]) => {
    // setSelectedClients(selectedValues);
    setSelectAllChecked(
      form.getFieldValue(["clientRoleList", 0, "id"]).length ===
        clientList?.length
    );
  };

  // console.log("forms", form.getFieldValue(["clientRoleList", 0, "id"]));

  //  Post user
  const saveData = () => {
    form.validateFields().then(async (val: any) => {
      setBtnLoading(true);

      var hashValue = MD5(val.password).toString();

      const removeClientIdData = val?.clientSpecificRole
        ? val?.clientRoleList?.filter((x: any) => x?.id?.value !== undefined)
        : val?.clientRoleList;

      console.log(
        "removeClientIdData",
        val,
        removeClientIdData,
        removeClientIdData?.length > 0
      );

      if (removeClientIdData?.length > 0) {
        let data = {
          ...val,
          name: {
            first: val?.first,
            last: val?.last,
          },
          password: hashValue,
          rePassword: hashValue,
          parentId: Utils.getLocal("ao-user")?.id,
          roleClientsType: selectClientsType,
          products: getProducts(),
          clientRoleList: val?.clientSpecificRole
            ? removeClientIdData?.map((x: any) => {
                return {
                  ...x,
                  id: [x.id?.value],
                  roleId: x.roleId?.value,
                };
              })
            : [
                {
                  id: removeClientIdData[0]?.id,
                  roleId: removeClientIdData[0]?.roleId?.value,
                },
              ],
        };
        // console.log("value", data);
        let res = await UsersService?.postUserData(data, editUserId);
        if (res?.status) {
          console.log("res", res);
          setBtnLoading(false);
          notification.success({
            message: "Success",
            description: `User ${
              editUserId ? "updated" : "added"
            } successfully.`,
          });
          setRefresh((x: boolean) => !x);
          onCancel(false);
        } else {
          notification.error({
            message: "Error",
            description: res?.message,
          });
          setBtnLoading(false);
        }
      } else {
        notification.error({
          message: "Error",
          description: "Please select at least one client.",
        });
        setBtnLoading(false);
      }
      // console.log("val", val);
    });
  };

  // console.log("selectedClients", selectedClients);

  const getAllRoleIdNameList = async (clientID: string, index: number) => {
    try {
      let res = await ClientRoleServices.getAllRoleIdNameList([clientID]);
      console.log("res 111", res.result);
      if (res.result?.length > 0) {
        // const data = res?.result?.map((x: IIdNameModel) => {
        //   return {
        //     label: x.name,
        //     value: x.id,
        //   };
        // });
        setClientSpecificRoleList((prevDataArray) => {
          const newArray = [...prevDataArray];
          newArray[index] =
            res?.result[0]?.roleData?.length > 0
              ? res?.result[0]?.roleData
              : [];
          return newArray;
        });
      } else {
        setClientSpecificRoleList((prevDataArray) => {
          const newArray = [...prevDataArray];
          newArray[index] = [];
          return newArray;
        });
      }
    } catch (ex) {
      console.error("error", ex);
    } finally {
    }
  };

  const onchangeClientSpecificRole = (clientID: string, index: number) => {
    if (clientID) {
      setSelectedClientId((prevState) => {
        const updatedSelectedOptions = [...prevState];
        updatedSelectedOptions[index] = clientID;
        return updatedSelectedOptions;
      });
      getAllRoleIdNameList(clientID, index);
    }
  };

  const dataSetNewClientRole = (x: any) => {
    // console.log("x", x);
    if (x.roleId && x.roleName) {
      const data = clientSpecificRoleList[newClientRoleIndex];
      setClientSpecificRoleList((prevDataArray) => {
        const newArray = [...prevDataArray];
        newArray[newClientRoleIndex] = [
          ...data,
          {
            id: x.roleId,
            name: x.roleName,
          },
        ];
        return newArray;
      });
    }
  };

  EntryLevelKeys({
    save: () => saveData(),
    cancel: () => onCancel(false),
  });

  return (
    <div>
      <Drawer
        title={editUserId ? "Edit User" : "Add User"}
        maskClosable={false}
        open={isModelOpen}
        closable={false}
        width={650}
        extra={
          <Space>
            <CloseOutlined onClick={() => onCancel()} />
          </Space>
        }
        footer={
          <div style={{ marginTop: "0px" }}>
            <Space
              style={{
                display: "flex",
                justifyContent: "end",
                marginRight: 7,
              }}
            >
              <Tooltip
                title={<p>ALT+C</p>}
                placement="bottomLeft"
                open={showKeys}
              >
                <Button
                  onClick={() => {
                    form.resetFields();
                    onCancel();
                  }}
                >
                  Cancel
                </Button>
              </Tooltip>

              <Tooltip
                title={<p>ALT+S</p>}
                placement="bottomLeft"
                open={showKeys}
              >
                <Button
                  type="primary"
                  onClick={() => saveData()}
                  loading={btnLoading}
                  className="modelSaveButtonMargin"
                            // style={{marginLeft:"10px"}}
                            style={{ width: 150 }}
                >
                  {editUserId ? "Update" : "Save"}
                </Button>
              </Tooltip>
            </Space>
          </div>
        }
        className="ledgerdrawerstyle"
      >
        <Spin indicator={antIcon} spinning={drawerLoading}>
          <Form
            // requiredMark={false}
            form={form}
            // labelCol={{ span: 6 }}
            labelAlign="left"
            // layout="horizontal"
            layout="vertical"
            name="userData"
            initialValues={{ clientRoleList: [{}] }}
          >
            <Row gutter={14}>
              <Col sm={12} xs={24}>
                <Form.Item
                  label="First Name"
                  className="input-item"
                  name="first"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your first name",
                    },
                    {
                      pattern: /^[A-Za-z\s]+$/,
                      message: "First name can only contain letters and spaces",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col sm={12} xs={24}>
                <Form.Item
                  label="Last Name"
                  className="input-item"
                  name="last"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your last name.",
                    },
                    {
                      pattern: /^[A-Za-z\s]+$/,
                      message: "First name can only contain letters and spaces",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col sm={12} xs={24}>
                <Form.Item
                  label="Email"
                  className="input-item"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your email.",
                    },
                    {
                      type: "email",
                      message: "The entered email is not valid!",
                    },
                  ]}
                >
                  <Input type="email" />
                </Form.Item>
              </Col>

              <Col sm={12} xs={24}>
                <Form.Item
                  label="Phone"
                  className="input-item"
                  name="phoneNumber"
                  rules={[
                    // {
                    //   required: true,
                    //   message: "Please enter your phone number",
                    // },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Phone number must be between 10 digits!",
                    },
                  ]}
                >
                  <Input
                    type="tel"
                    maxLength={10}
                    placeholder="Enter your phone number."
                    onInput={(e: any) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                  />
                </Form.Item>
              </Col>

              {!editUserId && (
                <>
                  <Col sm={12} xs={24}>
                    <Form.Item
                      label="Password"
                      name="password"
                      className="input-item"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your password.",
                        },
                        {
                          pattern:
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={}\[\]:;"'<>,.?~`\\|-])[A-Za-z\d!@#$%^&*()_+={}\[\]:;"'<>,.?~`\\|-]{6,}$/,
                          message:
                            "Password must be at least 6 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character!",
                        },
                      ]}
                    >
                      <Input.Password size="middle" />
                    </Form.Item>
                  </Col>

                  <Col sm={12} xs={24}>
                    <Form.Item
                      label="Re-Password"
                      name="rePassword"
                      className="input-item"
                      rules={[
                        {
                          required: true,
                          message: "Please confirm your password.",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue("password") === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("The password do not match!")
                            );
                          },
                        }),
                      ]}
                    >
                      <Input.Password size="middle" />
                    </Form.Item>
                  </Col>
                </>
              )}

              <Col sm={12} xs={24}>
                <Form.Item
                  label="Select Clients"
                  // name="selectClientsType"
                  className="input-item"
                >
                  <Radio.Group
                    value={selectClientsType}
                    onChange={(e) => {
                      setSelectClientsType(e.target.value);
                      if (
                        e.target.value === SelectClientsType.AllClients &&
                        isClientWiseRole
                      ) {
                        form.setFieldValue(["clientRoleList"], [{}]);
                        setSelectAllChecked(false);
                        setSelectedClientId([]);
                        // form.setFieldValue(["clientRoleList", "roleId"], {});
                      }
                    }}
                  >
                    <Radio value={SelectClientsType.AllClients}>
                      All Clients
                    </Radio>
                    <Radio value={SelectClientsType.SelectClients}>
                      Specified Clients
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>

              {selectClientsType === SelectClientsType.SelectClients && (
                <Col sm={12} xs={24}>
                  <Form.Item
                    label="Client-Specific Role"
                    name="clientSpecificRole"
                    className="input-item"
                    valuePropName="checked"
                  >
                    <Checkbox
                      value={isClientWiseRole}
                      onChange={(e) => {
                        form.setFieldValue(["clientRoleList"], [{}]);
                        setSelectAllChecked(false);
                        setSelectedClientId([]);
                        setisClientWiseRole(e.target.checked);
                      }}
                    />
                  </Form.Item>
                </Col>
              )}

              {selectClientsType === SelectClientsType.SelectClients &&
              isClientWiseRole ? (
                <div
                  style={{
                    // maxWidth: window.innerWidth <= 425 ? "800px" : "",
                    width: "100%",
                    overflowX: "auto",
                  }}
                >
                  <table style={{ width: "100%", overflowX: "auto" }}>
                    <thead>
                      <tr>
                        <th
                          style={{ width: "35%" }}
                          className="textStart fw-500"
                        >
                          Client
                        </th>
                        <th
                          style={{ width: "35%" }}
                          className="textStart fw-500"
                        >
                          Roles
                        </th>
                        <th
                          style={{ width: "15%" }}
                          className="textStart fw-500"
                        >
                          Add Role
                        </th>

                        <th style={{ width: "5%" }}></th>
                      </tr>
                    </thead>
                    <Form.List name="clientRoleList">
                      {(fields, { add, remove }) => (
                        <>
                          <tbody>
                            {fields?.map(
                              ({ key, name, ...restField }, index) => (
                                <tr key={key}>
                                  <td>
                                    <Form.Item
                                      name={[name, "id"]}
                                      {...restField}
                                      // rules={
                                      //   [
                                      //     // {
                                      //     //   required: true,
                                      //     //   message:
                                      //     //     "Please select at leasted one Client.",
                                      //     // },
                                      //     // {
                                      //     //   required:
                                      //     //     index !== 0 &&
                                      //     //     !form.getFieldValue([
                                      //     //       "clientRoleList",
                                      //     //       index,
                                      //     //       "id",
                                      //     //     ])
                                      //     //       ? false
                                      //     //       : true,
                                      //     //   message: "Select Client",
                                      //     // },
                                      //   ]
                                      // }
                                      className="input-item"
                                    >
                                      <Select
                                        style={{ width: "100%" }}
                                        placeholder="Select..."
                                        labelInValue
                                        onChange={(x) => {
                                          onchangeClientSpecificRole(
                                            x.value,
                                            index
                                          );

                                          if (fields.length === index + 1)
                                            add();
                                        }}
                                        options={clientList
                                          ?.filter(
                                            (option: any) =>
                                              !selectedClientId?.includes(
                                                option?.id
                                              )
                                          )
                                          ?.map((x: any) => ({
                                            value: x?.id,
                                            label: x?.bName,
                                          }))}
                                      />
                                    </Form.Item>
                                  </td>
                                  <td>
                                    <Form.Item
                                      name={[name, "roleId"]}
                                      rules={[
                                        // {
                                        //   required: true,
                                        //   message: "Please select role.",
                                        // },
                                        {
                                          required:
                                            index !== 0 &&
                                            !form.getFieldValue([
                                              "clientRoleList",
                                              index,
                                              "id",
                                            ])
                                              ? false
                                              : true,
                                          message: "Please select role.",
                                        },
                                      ]}
                                      className="input-item"
                                    >
                                      <Select
                                        style={{ width: "100%" }}
                                        labelInValue
                                        onChange={(val) => {
                                          console.log("Val", val);
                                          if (
                                            customerRoleList.find(
                                              (x) => x.value === val.value
                                            )
                                          ) {
                                            form.setFieldValue(
                                              [
                                                "clientRoleList",
                                                index,
                                                "isClientRole",
                                              ],
                                              false
                                            );
                                          } else {
                                            form.setFieldValue(
                                              [
                                                "clientRoleList",
                                                index,
                                                "isClientRole",
                                              ],
                                              true
                                            );
                                            console.log("Client Role List");
                                          }
                                        }}
                                      >
                                        <OptGroup label="Customer Role">
                                          {customerRoleList?.map((item) => (
                                            <Option
                                              key={item.value}
                                              value={item.value}
                                            >
                                              {item.label}
                                            </Option>
                                          ))}
                                        </OptGroup>
                                        <OptGroup label="Client Role">
                                          {clientSpecificRoleList[index]?.map(
                                            (x: IIdNameModel) => (
                                              <Option key={x.id} value={x.id}>
                                                {x.name}
                                              </Option>
                                            )
                                          )}
                                        </OptGroup>
                                      </Select>
                                    </Form.Item>
                                  </td>
                                  <td>
                                    <Form.Item className="input-item">
                                      <Tooltip
                                        title={
                                          form.getFieldValue([
                                            "clientRoleList",
                                            index,
                                            "id",
                                          ])
                                            ? ""
                                            : "Please Select Client"
                                        }
                                      >
                                        <Button
                                          onClick={() => {
                                            const clientId = form.getFieldValue(
                                              ["clientRoleList", index, "id"]
                                            )?.value;

                                            // console.log(
                                            //   "id",
                                            //   clientId,
                                            //   form.getFieldValue([
                                            //     "clientRoleList",
                                            //     index,
                                            //     "id",
                                            //   ])
                                            // );
                                            setOpenModel({
                                              type: "addRole",
                                              clientId: clientId,
                                            });
                                            setNewClientRoleIndex(index);
                                          }}
                                          disabled={
                                            form.getFieldValue([
                                              "clientRoleList",
                                              index,
                                              "id",
                                            ])
                                              ? false
                                              : true
                                          }
                                        >
                                          <PlusOutlined /> Client Role
                                        </Button>
                                      </Tooltip>
                                    </Form.Item>
                                  </td>

                                  <td>
                                    {fields.length > 1 &&
                                      fields.length !== index + 1 && (
                                        <Form.Item className="input-item">
                                          <Button
                                            style={{
                                              padding: "0px",
                                              borderColor: "#fff",
                                              boxShadow: "none",
                                            }}
                                            onClick={() => {
                                              setSelectedClientId((prev) => {
                                                const newDisabledInputs = [
                                                  ...prev,
                                                ];
                                                newDisabledInputs.splice(
                                                  name,
                                                  1
                                                );
                                                return newDisabledInputs;
                                              });
                                              setClientSpecificRoleList(
                                                (prev) => {
                                                  const allPrevArray = [
                                                    ...prev,
                                                  ];
                                                  // console.log(
                                                  //   "allPrevArray----------",
                                                  //   allPrevArray,
                                                  //   deleteItemList.index
                                                  // );
                                                  allPrevArray.splice(name, 1);
                                                  return allPrevArray;
                                                }
                                              );
                                              remove(name);
                                            }}
                                          >
                                            <DeleteTwoTone
                                              className="ca-delete-btn"
                                              twoToneColor="#ff879d"
                                            />
                                          </Button>
                                        </Form.Item>
                                      )}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>

                          {/* <tfoot>
                              <tr>
                                <td>
                                  <Form.Item className="inputBoxMb">
                                    <Row>
                                      <Col>
                                        <Button
                                          type="link"
                                          onClick={() => add()}
                                          block
                                          icon={<PlusOutlined />}
                                        >
                                          Add Contact
                                        </Button>
                                      </Col>
                                    </Row>
                                  </Form.Item>
                                </td>
                              </tr>
                            </tfoot> */}
                        </>
                      )}
                    </Form.List>
                  </table>
                </div>
              ) : (
                <>
                  <Form.List name="clientRoleList">
                    {(fields, { add, remove }) => (
                      <>
                        {/* {fields?.map(({ key, name, ...restField }, index) => ( */}
                        {selectClientsType ===
                          SelectClientsType.SelectClients && (
                          <Col sm={12} xs={24}>
                            <Form.Item
                              name={[0, "id"]}
                              label="Clients"
                              rules={[
                                // {
                                //   validator: (_, value) => {
                                //     if (value && value.length > 0) {
                                //       return Promise.resolve();
                                //     }
                                //     return Promise.reject(
                                //       new Error(
                                //         "Please select at least one client."
                                //       )
                                //     );
                                //   },
                                {
                                  required: true,
                                  message: "Please select at least one client.",
                                },
                              ]}
                              className="input-item"
                            >
                              <Select
                                mode="multiple"
                                style={{ width: "100%" }}
                                placeholder="Select..."
                                onChange={(e) => {
                                  // form.validateFields(["clientRoleList"]);
                                  handleSelectChange(e);
                                }}
                                options={clientList?.map((client: any) => ({
                                  value: client?.id,
                                  label: client?.bName,
                                }))}
                              />
                            </Form.Item>
                            <span>
                              <Checkbox
                                style={{ margin: "5px 5px 0px 0px" }}
                                checked={selectAllChecked}
                                onChange={handleSelectAll}
                              >
                                Select all clients
                              </Checkbox>
                            </span>
                          </Col>
                        )}
                        <Col sm={12} xs={24}>
                          <Form.Item
                            name={[0, "roleId"]}
                            label="Role"
                            rules={[
                              {
                                required: true,
                                message: "Please select role.",
                              },
                            ]}
                            className="input-item"
                          >
                            <Select
                              labelInValue
                              style={{ width: "100%" }}
                              options={customerRoleList}
                            />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </Form.List>
                </>
              )}
            </Row>

            {/* <Divider className="ca-model-css" /> */}
          </Form>
        </Spin>
      </Drawer>
      {openModel.type === "addRole" && (
        <AddCompanyRoles
          open={true}
          onCancel={() => setOpenModel({ type: "", clientId: "" })}
          clientId={openModel.clientId}
          drawerPlacement="left"
          setTrigger={setTrigger}
          setAddNewClientRole={dataSetNewClientRole}
          // id={}
        />
      )}
    </div>
  );
};

export default AddUser;

/* <Col sm={12} xs={24}>
                <Form.Item
                  name="clientRoleList"
                  label="Companies"
                  rules={[
                    {
                      required: true,
                      message: "Please select at leasted one company.",
                    },
                  ]}
                  className="input-item"
                >
                  <Select
                    mode="multiple"
                    style={{ width: "100%" }}
                    placeholder="Select..."
                    value={selectedClients}
                    onChange={handleSelectChange}
                    options={clientList?.map((client: any) => ({
                      value: client?.id,
                      label: client?.bName,
                    }))}
                  />
                  <span>
                    <Checkbox
                      style={{ margin: "5px 5px 0px 0px" }}
                      checked={selectAllChecked}
                      onChange={handleSelectAll}
                    />
                    Select All Companise
                  </span>
                </Form.Item>
              </Col> */

/* <Col sm={12} xs={24}>
                <Form.Item
                  label="Role"
                  name="role"
                  rules={[
                    {
                      required: true,
                      message: "Please select role.",
                    },
                  ]}
                  className="input-item"
                >
                  <Select
                    style={{ width: "100%" }}
                    options={[
                      {
                        value: "ADMIN",
                        label: "Admin",
                      },
                      {
                        value: "AUTHORITIES",
                        label: "Authorities",
                      },
                      {
                        value: "DATAENTRY",
                        label: "Data Entry",
                      },
                      {
                        value: "AUDITORS",
                        label: "Auditors",
                      },
                      {
                        value: "VIEWONLY",
                        label: "View Only",
                      },
                    ]}
                    onChange={(val: any) => setSelectRole(val)}
                  />
                </Form.Item>
              </Col> */
